<template>
  <div class="wgtSettings" :class="{ 'isTableShown': isShowTable }">
    <div class="cardR">
      <div class="boxR">
        <div class="myZoomClass" :class="$store.state.TClrs" id="wordsnap">
          <div class="content-panel1" v-show="IswordErr">
            <h2 class="chartTitle hide-on-presentation themeclr2">{{ wordCloudTitle }}</h2>
            <apiErrorComponent @tryReload="tryReload" :compTitle="wordCloudTitle" compId="wordsnap">
            </apiErrorComponent>
          </div>
          <div class="content-panel1" v-show="!IswordErr" ref="screenShot">
            <div class="insideL  hide-on-presentation ">
              <div class="icon">
                <font-awesome-icon icon="fa-solid fa-bars" />
              </div>
              <div class="contents">
                <span v-show="!IswordErr">
                  <font-awesome-icon :icon="['fas', 'eye']" title="Show Blank Values" v-on:click="removeBlank(false)"
                    v-show="isRemoveBlank" />
                  <font-awesome-icon :icon="['fas', 'eye-slash']" title="Hide Blank Values" v-on:click="removeBlank(true)"
                    v-show="!isRemoveBlank" />
                  <font-awesome-icon icon="fa-solid fa-diagram-successor" title="Switch to Alternate View"
                    v-on:click="swapCharts()" />
                  <font-awesome-icon icon="fa-solid fa-table" v-on:click="showTable()"
                    :title="isShowTable ? 'Hide Table' : 'Show Table'" />
                  <font-awesome-icon icon="fa-solid fa-chalkboard-teacher" v-on:click="addToSlider()"
                    title="Add to Storyboard" />
                  <font-awesome-icon icon="fa-solid fa-file-download" title="Download Widget"
                    v-on:click="downloadDom()" />
                  <font-awesome-icon icon="fa-solid fa-file-export" title="Export Insights" v-on:click="downIns()" />
                </span>
              </div>
            </div>
            <div class="insideR hide-on-presentation">
              <div class="icon">
                <font-awesome-icon icon="fa-solid fa-info" />
              </div>
              <div class="contents">
                {{ $parent.wcinfo }} You can click on individual words/bars to get more insights.<br /><br />
                Actions you can take on this widget: <br />
                <ul>
                  <li>Click on
                    <font-awesome-icon class="actIcon" :icon="['fas', 'eye']" /> to see non blank values and
                    <font-awesome-icon class="actIcon" :icon="['fas', 'eye-slash']" /> to see blank values
                  </li>
                  <li>Click on
                    <font-awesome-icon class="actIcon" icon="fa-solid fa-diagram-successor" /> to swap between bar and
                    word cloud view
                  </li>
                  <li>Click on
                    <font-awesome-icon class="actIcon" icon="fa-solid fa-table" /> to see table with values
                  </li>
                  <li>Click on
                    <font-awesome-icon class="actIcon" icon="fa-solid fa-chalkboard-teacher" /> to add to storyboard
                  </li>
                  <li>Click on
                    <font-awesome-icon class="actIcon" icon="fa-solid fa-file-download" /> to download the chart with
                    current insight
                  </li>
                  <li>Click on
                    <font-awesome-icon class="actIcon" icon="fa-solid fa-file-export" /> to download all the insights
                  </li>
                </ul>
              </div>
            </div>
            <div v-show="!isLoadWord">
              <widgetLoadingComp></widgetLoadingComp>
            </div>
            <div v-show="isLoadWord"></div>
            <h2 class="chartTitle hide-on-presentation themeclr2">{{ wordCloudTitle }}</h2>
            <div class="panel-body text-center" :class="{ 'BlurClass': !isLoadWord }">
              <div class="dropmarg">
                <VueMultiselect class="mymultiselect  hide-on-presentation " openDirection="bottom" v-model="wcFilterOp" :options="WCFilteron"
                  :multiple="false" :allow-empty="false" deselect-label="can't Deselect" :close-on-select="true"
                  @select="getWordCloud" placeholder="Pick" track-by="name" label="name" selectLabel="" />
              </div>
              <div class="chartHeightControlWC" v-show="Iswordload">
                <div id="wcChart"></div>
              </div>
              <div v-if="isShowTable">
                <div v-on:click="onBtnExport()" class="myfaBtn spl hide-on-presentation">
                  <font-awesome-icon :icon="['fas', 'fa-download']" />
                </div>
                <ag-grid-vue style="width: 96%;height:470px;"
                  class="table-striped thmHead myMttrTbl v01 ag-theme-alpine myHomeTable" :columnDefs="asgcolsDefs"
                  @grid-ready="onAsgReady" :modules="modules">
                </ag-grid-vue>
              </div>
              <div v-if="IswordErr">
                <widgetErrorImg></widgetErrorImg>
              </div>
              <div v-if="IsWordData" class="text-center">
                <widgetDataMsg></widgetDataMsg>
              </div>
            </div>
            <widgetsSlider :insideArr="wordinsight.map(x => x.ins)" :isInsErr="IswcInsErr" :compTitle="wordCloudTitle"
              compId="wordsnap" :isErr="false"></widgetsSlider>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  useRoute
} from 'vue-router';
import * as echarts from 'echarts';
import 'echarts-wordcloud';
import {
  AgGridVue
} from "@ag-grid-community/vue3";
import {
  ClientSideRowModelModule
} from "@ag-grid-community/client-side-row-model";
import {
  CsvExportModule
} from "@ag-grid-community/csv-export";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import widgetDataMsg from '../smallcomp/chartDataMsg.vue'
import widgetErrorImg from '../smallcomp/chartDataMsg.vue'
import widgetLoadingComp from '../smallcomp/widgetloader.vue'
import apiErrorComponent from '../smallcomp/apierror.vue'
import domtoimage from "dom-to-image-more";
import screenShotMix from "./../../mixin/screenShotMix";
import widgetsSlider from '../smallcomp/widgets-slider.vue';
import {
  saveAs
} from 'file-saver';
var insFltr, insAnalyse_db, insCue
var wcfilterop
var myWCChart
var wordwholedata
var captureWidget = true;
function reportWindowSizeWC() {
  if (myWCChart != undefined) {
    myWCChart.resize()
  }
}
export default {
  name: 'WordCloud',
  mixins: [screenShotMix],
  components: {
    widgetDataMsg,
    widgetErrorImg,
    AgGridVue,
    widgetLoadingComp,
    apiErrorComponent,
    widgetsSlider
  },
  props: {
    getpass: Object,
    getPins: Object,
    tabname: String,
  },
  data() {
    return {
      modules: [ClientSideRowModelModule, CsvExportModule],
      isRemoveBlank: false,
      isLoadWord: false,
      Iswordload: false,
      IswordErr: false,
      IsWordData: false,
      IswcInsErr: false,
      isShowTable: false,
      wordchart: [],
      wordinsight: [],
      wcdrill: "",
      wordCloudTitle: "",
      gradientRed: this.getgradRed,
      gradientGreen: this.getgradGreen,
      WCFilteron: this.getpass.WCFilteron,
      wcFilterOp: "",
      isWCshow: true,
      slickOptions: {
        slidesToShow: 3
      },
      asgLisApi: null,
      asgLis: null,
      asgcolsDefs: [],
      paginNo: 0,
      paginIdx: "transform: translateX(0%)",
      myWordCTitle: "",
      tooltipPos: "display:none",
      isChartRedraw: true,
    }
  },
  methods: {
    tryReload() {
      this.getWordCloud(this.wcFilterOp, this.getwgtCond)
    },
    addToSlider() {
      let insArr = [];
      let name = this.wordCloudTitle + " for " + this.wcFilterOp.name + " - " + this.getPins.viewName;
      let screenShort = {
        id: 'wordsnap',
        name: 'World_Map.png'
      }
      for (let i = 0; i < this.wordinsight.length; i++) {
        insArr.push(this.wordinsight[i].ins);
      }
      if (insArr.length == 0) {
        for (let i = 0; i < this.wordinsightBack.length; i++) {
          insArr.push(this.wordinsightBack[i].ins);
        }
      }
      captureWidget = false;
      this.drawCloud()
      setTimeout(() => {
        this.addToSliderMix(screenShort, insArr, name)
      }, 3000);
      setTimeout(() => {
        captureWidget = true;
        this.drawCloud()
      }, 6000);

    },
    onAsgReady(params) {
      this.asgLisApi = params.api
      this.gridColumnApi = params.columnApi
      this.asgLisApi.setRowData(this.asgLis);
      params.api.sizeColumnsToFit();
    },
    onBtnExport() {
      this.asgLisApi.exportDataAsCsv();
    },
    percGetter(params) {
      return params.data.Percentage + '%'
    },
    myPercComparator(v1, v2, n1, n2) {
      v1 = parseFloat(v1.slice(0, -1))
      v2 = parseFloat(v2.slice(0, -1))
      return v1 - v2
    },
    numberValueFormatter(params) {
      return params.value.toLocaleString();
    },
    showTable() {
      if (this.isShowTable) {
        this.isShowTable = false
      } else {
        if (this.isRemoveBlank) {
          this.asgLis = this.wordchart;
        } else {
          this.asgLis = this.wordchartBlank;
        }
        this.asgcolsDefs = [{
          headerName: this.wcFilterOp.name,
          field: 'value',
          sortable: true,
          resizable: true
        },
        {
          headerName: '# Tickets',
          field: 'count',
          type: 'numericColumn',
          valueFormatter: this.numberValueFormatter,
          sortable: true,
          resizable: true
        },
        {
          headerName: 'Percentage',
          field: 'Percentage',
          type: 'numericColumn',
          sortable: true,
          comparator: this.myPercComparator,
          valueGetter: this.percGetter,
          resizable: true
        },
        ]
        this.isShowTable = true;
      }
    },
    downloadDom() {
      let imgname = "WordCloud_Chart.png"
      let widgetID = "wordsnap"
      captureWidget = false;
      this.drawCloud()
      const self = this;
      var geticondiv = document.querySelectorAll('#wordsnap .insideL,#wordsnap .insideR, .hide-on-presentation')
      geticondiv.forEach(box => {
        box.style.opacity = 0;
      });
      document.getElementById(widgetID).classList.remove("myZoomClass")
      setTimeout(() => {
        domtoimage.toBlob(document.getElementById(widgetID))
          .then(function (blob) {
            saveAs(blob, imgname)
            geticondiv.forEach(box => {
              box.style.opacity = 1;
            });
            document.getElementById(widgetID).classList.add("myZoomClass")
            captureWidget = true;
              self.drawCloud()
          })
      }, 2000);
    },
    downIns() {
      let fileName = 'wordcloud_Insights.txt'
      let insArr = []
      for (let i = 0; i < this.wordinsight.length; i++) {
        insArr.push(this.wordinsight[i].ins)
      }
      insArr = insArr.join("\r\n");
      let fileToSave = new Blob([insArr], {
        type: 'application/json',
        name: fileName
      });
      saveAs(fileToSave, fileName)
    },
    removeBlank(condition) {
      this.wordchart = wordwholedata.getwc.slice(0)
      this.asgLis = this.wordchart;
      if (this.asgLisApi != null) {
        if (condition) {
          this.asgLisApi.setRowData(this.wordchart);
        } else {
          this.asgLisApi.setRowData(this.wordchartBlank);
        }
      }
      let cond
      if (condition) {
        this.isRemoveBlank = true;
        cond = 1
      } else {
        this.isRemoveBlank = false;
        cond = 0
      }
      setTimeout(() => {
        if (this.isWCshow) {
          this.drawCloud(cond);
        } else {
          if (!condition) {
            for (let i = 0; i < this.wordchart.length; i++) {
              if (this.wordchart[i].value == "(Blanks)") {
                this.wordchart.splice(i, 1)
                i--
              }
            }
          }
          this.drawChart();
        }
      }, 500);
    },
    swapCharts() {
      this.isWCshow = !this.isWCshow;
      setTimeout(() => {
        if (this.isWCshow) {
          this.drawCloud(0);
        } else {
          this.drawChart();
        }
      }, 500);
    },
    drawCloud(cond) {
      let emit = this.$emit
      let thisHldr = this
      let wordArr = [];
      let maxLen = 50
      if (this.isRemoveBlank) {
        for (let index = 0; index < this.wordchart.length; index++) {
          const element = this.wordchart[index];
          if (index < maxLen) {
            wordArr.push({
              name: (captureWidget && element.Percentage > 1) ? element.value.slice(0, 20) : element.value,
              // name: element.value,
              nameNew: element.value,
              value: element.count,
              perc: element.Percentage
            })
          }
          maxLen++
        }
      } else {
        for (let index = 0; index < this.wordchartBlank.length; index++) {
          const element = this.wordchartBlank[index];
          if (index < maxLen) {
            wordArr.push({
              // name: element.Percentage > 1 ? element.value : element.value,
              name: (captureWidget && element.Percentage > 1) ? element.value.slice(0, 20) : element.value,
              // name: element.value,
              nameNew: element.value,
              value: element.count,
              perc: element.Percentage
            })
          }
          maxLen++
        }
      }
      let chartDomWC = document.getElementById('wcChart');
      if(chartDomWC == null) return;
      if (chartDomWC != null && chartDomWC != undefined) {
        chartDomWC.style.height = "345px";
        if (this.isChartRedraw) {
          this.isChartRedraw = false;
          myWCChart = echarts.init(chartDomWC, null, {
            renderer: 'svg',
            useDirtyRect: false
          });
        }
        var option = {
          tooltip: {
            trigger: 'item',
            confine: true,
            formatter: (params) => {
              return params.marker + params.data.nameNew + ": " + params.data.value + "(" + params.data.perc + "%)";
            },
          },
          visualMap: {
            type: 'continuous',
            top: 0,
            left: 0,
            calculable: false,
            text: ['High', 'Low'],
            min: 0,
            max: wordArr[0].value,
            inRange: {
              color: this.$store.state.chartColor,
            },
            textStyle: {
              color: '#777',
              fontSize: 10
            },
          },
          grid: {
            top: 0,
            left: 60,
            right: 10,
            bottom: 0,
          },
          dataZoom: [{
            disabled: true,
            type: 'slider',
            show: false,
            start: 0,
            end: 15,
            handleSize: 8
          },
          {
            disabled: true,
            type: 'inside',
            start: 0,
            end: 15
          },
          {
            disabled: true,
            show: false,
            yAxisIndex: 0,
            filterMode: 'empty',
            width: 30,
            height: '80%',
            showDataShadow: false,
            left: '93%'
          }
          ],
          xAxis: {
            show: false,
            data: null,
          },
          yAxis: {
            show: false,
            data: null,
          },
          series: [{
            animationDurationUpdate: 1000,
            universalTransition: true,
            type: 'wordCloud',
            sizeRange: [8, 25],
            rotationRange: [0, 0],
            gridSize: 1,
            shape: 'circle',
            width: '80%',
            height: '100%',
            keepAspect: false,
            drawOutOfBound: true,
            shrinkToFit: false,
            layoutAnimation: false,
            emphasis: {
              selectorLabel: {
                overflow: 'truncate',
              },
              focus: 'self',
              textStyle: {
                textShadowBlur: 10,
                textShadowColor: '#333'
              }
            },
            data: wordArr
          }]
        };
        myWCChart.setOption(option, null, {
          renderer: 'svg',
          useDirtyRect: false
        });
        myWCChart.on('click', function (params) {
          if (params.componentType === 'series') {
            let clickitem = {
              "currpass": params.data.nameNew,
              "filterop": wcfilterop.dbname
            }
            emit("getKDrill", clickitem)
          }
        });
      }
    },
    drawChart() {
      let emit = this.$emit
      let tag_bar = new Array();
      let tag_barl = new Array();
      if (this.wordchart.length > 0) {
        for (let i = 0; i < this.wordchart.length; ++i) {
          let x = this.wordchart[i];
          if ((x.value == "(Blanks)" && !this.isRemoveBlank)) {
            let qqq = 1
          } else {
            tag_bar.push({
              value: x.count,
              perc: x.Percentage
            });
            tag_barl.push(x.value)
          }
        }
      }
      let chartDomWC = document.getElementById('wcChart');
      if(chartDomWC == null) return;
      if (chartDomWC != null && chartDomWC != undefined) {
        chartDomWC.style.height = "345px"
        let option = {
          tooltip: {
            trigger: 'axis',
            confine: true,
            position: ['25%', '50%'],
            formatter: (params) => {
              return params[0].marker + params[0].axisValue + ": " + params[0].data.value + "(" + params[0].data
                .perc + "%)";
            },
          },
          visualMap: {
            type: 'continuous',
            top: 0,
            calculable: false,
            text: ['High', 'Low'],
            min: 0,
            max: tag_bar[0].value,
            inRange: {
              color: this.$store.state.chartColor,
            },
            textStyle: {
              color: '#777',
              fontSize: 10
            },
          },
          grid: {
            top: '1%',
            left: 80,
            bottom: 100
          },
          dataZoom: [{
            disabled: false,
            type: 'slider',
            show: true,
            start: 0,
            end: 15,
            handleSize: 8
          },
          {
            disabled: false,
            type: 'inside',
            start: 0,
            end: 15
          },
          {
            disabled: false,
            show: true,
            yAxisIndex: 0,
            filterMode: 'empty',
            width: 30,
            height: '80%',
            showDataShadow: false,
            left: '93%'
          }
          ],
          xAxis: {
            type: 'category',
            show: true,
            data: tag_barl,
            silent: false,
            splitLine: {
              show: false
            },
            splitArea: {
              show: false
            },
            axisLine: {
              show: true
            },
            axisLabel: {
              rotate: 30,
              width: 80,
              overflow: 'truncate',
              color: "#777",
              fontSize: 10
            },
          },
          yAxis: {
            type: 'value',
            show: true,
            splitArea: {
              show: false
            },
            splitLine: {
              show: false
            },
            axisLine: {
              show: true
            },
            axisLabel: {
              color: "#777",
              fontSize: 10
            },
          },
          series: [{
            itemStyle: {
              borderRadius: 2,
              opacity: 1
            },
            animationDurationUpdate: 1000,
            universalTransition: true,
            type: 'bar',
            data: tag_bar
          }]
        };
        myWCChart.setOption(option);
        myWCChart.on('click', function (params) {
          if (params.componentType === 'series') {
            let clickitem = {
              "currpass": params.name,
              "filterop": wcfilterop.dbname
            }
            emit("getKDrill", clickitem)
          }
        });
      }
    },
    getWordCloud(filtersel, cond) {
      let getfilter
      cond = this.getwgtCond
      this.IswordErr = false
      this.isLoadWord = false
      this.Iswordload = true
      this.IsWordData = false
      this.wordinsight = []
      wcfilterop = this.wcFilterOp
      if (this.wcdrill == "isopen") {
        getfilter = {
          "analyseby": insFltr,
          "filterP": insAnalyse_db,
          "Inscue": insCue
        }
      } else {
        if (getfilter != "") {
          getfilter = {
            "analyseby": filtersel.dbname
          }
        }
      }
      switch (cond) {
        case 0:
          this.wordCloudTitle = "Word Cloud by Count"
          break
        case 1:
          this.wordCloudTitle = "Word Cloud by Count"
          break
        case 2:
          this.wordCloudTitle = "Word Cloud by High Acknowledgement Time"
          break
        case 3:
          this.wordCloudTitle = "Word Cloud by High Resolution Time"
          break
        case 4:
          this.wordCloudTitle = "Word Cloud by Reopen count"
          break
        case 5:
          this.wordCloudTitle = "Word Cloud by Reassignment count"
          break
        default:
          cond = 0
          break
      }
      this.axios.post(this.uriApiUrl + 'DataAnalysis/wordcloudview?Cond=' + cond + "&asg_id=" + this.asgId, {
        "colval": getfilter,
        "selid": this.getPins.selid,
        "edited": this.getPins.edited
      },{
      headers: {
            'Content-Type': 'application/json'
          }})
        .then((response) => {
          this.myWordCTitle = "Hover over words to see Ticket Count and Percentage";
          if (response.status == 200) {
            if (response.data != "Error" && response.data != "Nodata") {
              wordwholedata = response.data
              this.wordchart = JSON.parse(JSON.stringify(wordwholedata.getwc.slice(0)))
              this.wordchartBlank = JSON.parse(JSON.stringify(wordwholedata.getwc.slice(0)))
              for (let i = 0; i < this.wordchartBlank.length; i++) {
                let element = this.wordchartBlank[i]
                if (element.value == "(Blanks)") {
                  this.wordchartBlank.splice(i, 1)
                  i--
                }
              }
              this.wordinsight = wordwholedata.insights
              for (let i = 0; i < this.wordinsight.length; i++) {
                this.wordinsight[i].ins = this.wordinsight[i].ins.replace(/\|/g, '').replace(/~/g, '')
              }
              if (this.wordinsight.length == 0) {
                this.IswcInsErr = true
              }
              if (this.isChartRedraw) {
                try {
                  echarts.dispose(myWCChart);
                } catch (error) {
                  // console.log("..")
                }
              }
              setTimeout(() => {
                if (this.isWCshow) {
                  this.drawCloud(0);
                } else {
                  this.drawChart();
                }
              }, 500);
            } else if (response.data == "Nodata") {
              this.IsWordData = true
              this.wordinsight = []
            } else {
              this.IswordErr = true
              this.wordinsight = []
              this.IswcInsErr = true
              this.$notify({
                type: "error",
                text: 'Sorry! Something went wrong in Word Cloud. Try after sometime!'
              })
            }
            this.isLoadWord = true
          }
        }).catch((response) => {
          this.IswordErr = true
          this.isAnalysisload = false
          this.isLoadWord = true
          this.$notify({
            type: "error",
            text: 'Sorry! Something went wrong in Word Cloud. Try after sometime!'
          })
          if (this.enabledDebug == 1) {
            // console.log("Exception occured in Word Cloud:" + response)
          }
        })
    }
  },
  mounted() {
    const route = useRoute()
    this.asgId = route.params.asgid
    let selcol;
    if (this.WCFilteron != undefined) {
      let chkFilterOn = this.WCFilteron.find(element => element.ticked == true)
      selcol = chkFilterOn
      this.wcFilterOp = selcol
    }
    this.getWordCloud(selcol, this.getwgtCond);
    this.isChartRedraw = true
    window.addEventListener("resize", reportWindowSizeWC);
  },
  unmounted() {
    window.removeEventListener("resize", reportWindowSizeWC);
  },
  computed: {
    getwgtCond() {
      return this.$store.state.widgetCond
    },
    getgradCyan() {
      return this.$store.getters.getgradCyan
    },
  },
  watch: {
    '$store.state.chartColor': function () {
      if (myWCChart != undefined) {
        this.drawCloud()
      }
    }
  },
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.paneldropHt {
  height: 380px;
}

.dropmarg {
  margin: 0px 50px 10px 50px;
}

#my_datavizParent {
  width: 100%;
  position: relative;
  top: 0;
  left: 0;
}

.custom-tooltip {
  visibility: hidden;
  background-color: rgba(127, 127, 127, 0.9);
  z-index: 999;
  display: inline-block;
  position: absolute;
  color: rgb(255, 255, 255);
  padding: 8px;
  border-radius: 4px;
}

#my_datavizParent:hover .custom-tooltip {
  visibility: visible;
}</style>